import React from 'react';
import { Flex, Button, Form, Input, message, Checkbox } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import "./login.css"
// import PWAInstall from '../../components/pwa-install'
import { sendUserLoginToApp, detectWebView, openUrlExternally } from '../../utils/jsbridge';

const { isWebView } = detectWebView();

const Login = (props) => {
    const [loginForm] = Form.useForm();

    React.useEffect(() => {
        sendUserLoginToApp({});
    }, []);
    const onSubmit = async () => {
        console.log("所有字段值：", loginForm.getFieldsValue());  // 调试信息
        console.log("单独获取agree值：", loginForm.getFieldValue('agree'));  // 调试信息
        const data = await loginForm.validateFields();

        console.log("验证后的数据：", data);  // 调试信息

        // document.getElementById('loginForm').submit();
        let response = await fetch('/api/auth/virify', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        let result = await response.json();

        if(result && result.success) {
            
            const { accStatus, accId, userId } = result.data;
            // 获取URL returnUrl参数
            const url = new URL(window.location.href);
            let returnUrl = url.searchParams.get('return_url');
            // 仅当returnUrl是绝对URL（包含协议）且为http时，替换为https
            if (returnUrl) {
                returnUrl = decodeURIComponent(returnUrl);
                // 检查是否为绝对URL（包含协议）
                if (returnUrl.startsWith('http://')) {
                    returnUrl = returnUrl.replace('http://', 'https://');
                }
            } else {
                returnUrl = '/index'; // 保持原始逻辑
            }
            
            // 通过JS Bridge通知APP登录成功，并传递用户信息
            sendUserLoginToApp({
                userId: userId,
            });
            
            switch (accStatus) {
                case 0:
                    window.location.href = `/regist2?accId=${accId}`;
                    break;
                case 1:
                    setTimeout(() => {
                        window.location.href = '/waiting';
                    }, 500);
                    break;
                case 2:
                    setTimeout(() => {
                        window.location.href = returnUrl;
                    }, 500);
                    break;
                default:
                    setTimeout(() => {
                        window.location.href = returnUrl;
                    }, 500);
                    break;
            }
        } else {
            message.error('登录失败');
        }
    };

    return (
        <div className='loginBanner'>
            {/* <PWAInstall /> */}
            <Form
                form={loginForm}
                id='loginForm'
                name="basic"
                action="/login"
                method='post'
                style={{ width: '96%' }}
                autoComplete="off"
                className="loginForm"
            >
                <Flex gap={5} align='center' wrap> 
                    <h3 style={{ marginTop: "0" }}>优选到家管理系统</h3>
                    <a style={{margin: '0 0 15px 0'}} onClick={() => openUrlExternally('https://www.yxdj.tech/')}><QuestionCircleOutlined /></a>
                </Flex>
                {/* <div style={{ margin: '0 0 20px 0' }}>
                    <Radio.Group
                        name="radioGroup"
                        defaultValue={1}
                        buttonStyle="solid"
                    >
                        <Radio.Button value={1}>密码登录</Radio.Button>
                        <Radio.Button value={2}>短信登录</Radio.Button>
                    </Radio.Group>
                </div> */}
                <Form.Item
                    label=""
                    name="phoneNo"
                    rules={[
                        {
                            required: true,
                            message: '请输入手机号',
                        },
                    ]}
                >
                    <Input placeholder='手机号' />
                </Form.Item>
                <Form.Item
                    label=""
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: '请输入密码!',
                        },
                    ]}
                >
                    <Input placeholder='请输入密码' type='password' />
                </Form.Item>

                <Form.Item
                    label=""
                    name='agree'
                    valuePropName="checked"
                    rules={[
                        {
                            validator: (_, value) =>
                                value ? Promise.resolve() : Promise.reject(new Error('请阅读用户隐私协议和账户使用协议并同意'))
                        }
                    ]}
                >
                    <Checkbox id='agree'>
                        <span>已阅读并同意</span>
                        <a href='https://www.yxdj.tech/privacy-policy.html'>用户隐私政策</a>
                        <span>和</span>
                        <a href='https://www.yxdj.tech/account-usage-agreement.html'>账户使用协议</a>
                    </Checkbox>
                </Form.Item>
                {/* <Flex gap={10} wrap>
                    <Form.Item
                        label=""
                        name="code"
                        rules={[
                            {
                                required: true,
                                message: '请输入验证码!',
                            },
                        ]}
                    >
                        <Input placeholder='验证码' />
                    </Form.Item>
                    <Button>
                        获取验证码
                    </Button>
                </Flex> */}
                <div style={{display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                    <Button href='/regist' type='default' style={{ width: "100%", background: "#ffffff" }}>
                        注册
                    </Button>
                    <Button type='primary' onClick={onSubmit} htmlType="submit" style={{ width: "100%" }}>
                        登录
                    </Button>
                </div>
                <Flex style={{ margin: '10px 0 0 0', textAlign: 'right' }} align='end' justify='end' gap={10}>
                    <a onClick={() => openUrlExternally('https://www.yxdj.tech/')}><QuestionCircleOutlined /> 了解优选到家</a>
                    <a href='/forget'>忘记密码？</a>
                </Flex>
            </Form>
            <p style={{position: 'fixed', bottom: '10px', width: '100%', textAlign: 'center'}}>
                ©{new Date().getFullYear()} <a onClick={() => openUrlExternally('https://www.yxdj.tech/')}>杭州优选到家科技有限公司</a> 版权所有<br />浙ICP备2025162413号-3
            </p>
        </div>

    )
}

export default Login;